const Features = () => {
    return (
        <section id="features" className="wide-60 features-section division">
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-lg-10 col-xl-8">
                        <div className="section-title title-01 mb-70">
                            <h2 className="h2-md">Translation projects dragging on? Endless emails and lost files?</h2>
                            <p className="p-xl">
                                Rush Studio simplifies it all — upload your documents, assign translators, chat in real time, and track progress in one place. No more scattered threads or confusing file versions.
                            </p>
                        </div>
                    </div>
                </div>
                <div className="fbox-8-wrapper text-center">
                    <div className="row row-cols-1 row-cols-md-3">
                        <div className="col">
                            <div className="fbox-8 mb-40 wow fadeInUp">
                                <div className="fbox-img bg-whitesmoke-gradient">
                                    <img className="img-fluid" src="/images/demo6/Feature 1.png" alt="feature-icon" />
                                </div>
                                <h5 className="h5-md">Centralised Project Management</h5>
                                <p className="p-lg">
                                    Keep every file, translation, and update organized in one place. Rush Studio’s dashboard gives you a clear overview of all your projects — deadlines, progress, and team activity at a glance.
                                </p>
                            </div>
                        </div>
                        <div className="col">
                            <div className="fbox-8 mb-40 wow fadeInUp">
                                <div className="fbox-img bg-whitesmoke-gradient">
                                    <img className="img-fluid" src="/images/demo6/Feature 2.png" alt="feature-icon" />
                                </div>
                                <h5 className="h5-md">Real-Time Collaboration</h5>
                                <p className="p-lg">
                                    Communicate instantly with your translators and reviewers through built-in chat. Discuss changes, share context, and resolve issues without ever leaving the project.
                                </p>
                            </div>
                        </div>
                        <div className="col">
                            <div className="fbox-8 mb-40 wow fadeInUp">
                                <div className="fbox-img bg-whitesmoke-gradient">
                                    <img className="img-fluid" src="/images/demo6/Feature 3.png" alt="feature-icon" />
                                </div>
                                <h5 className="h5-md">Smart Translation Tools</h5>
                                <p className="p-lg">
                                    Speed up your workflow with intelligent translation memory and glossaries. Reuse past translations, maintain consistency, and ensure your content sounds right every time.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Features;
